<script setup>
    import NavBar from './NavBar.vue';
    import { ref, provide, onMounted, onUnmounted } from 'vue';
    import { Notificaciones as NotificacionesApi } from '../Api/API_Concentrador';
    import {useMarketplaceCredentials} from '../stores/marketplaceCredentials.store'; 
    import i18n from '../langs/i18n';
    import LeftBar from './LeftBar.vue';


    const htmlBar = ref(null);
    const ajustesVisibles = ref(false);
    const notificaciones = ref([]);
    const marketplaceCredentials = useMarketplaceCredentials();

    provide('mostrarAjustes', ajustesVisibles);
    provide('notificaciones', notificaciones);

    function notificacionNavegador(message) {
        const mensaje_notificacion = message;
        if (!("Notification" in window)) {
            alert("Tu navegador no soporta notificaciones");
        } else if (Notification.permission === "granted") {
            const notification = new Notification(mensaje_notificacion);
        } else if (Notification.permission !== "denied") {
            Notification.requestPermission().then((permission) => {
                if (permission === "granted") {
                    const notification = new Notification(mensaje_notificacion);
                }
            });
        }
    }

    // DGL-317: un corte de red o un reinicio del backend no es un error para el usuario.
    // Se reconecta en silencio, sin límite de intentos, y solo si la desconexión se alarga
    // se muestra un aviso discreto en el NavBar.
    const ESPERA_MAXIMA_MS = 30000;
    const UMBRAL_AVISO_MS = 30000;

    const socketReconectando = ref(false);
    provide('socketReconectando', socketReconectando);

    let ws = null;
    let intentos = 0;
    let huboDesconexion = false;
    let desmontado = false;
    let temporizadorReconexion = null;
    let temporizadorAviso = null;

    function cargarNotificaciones(){
        NotificacionesApi.get().then((res) => {
            notificaciones.value = res.data.map(n=> n.data)
        }).catch(() => console.log('No se pudieron cargar las notificaciones'));
    }

    function programarReconexion(){
        if (desmontado || temporizadorReconexion) return;
        if (!temporizadorAviso && !socketReconectando.value) {
            temporizadorAviso = setTimeout(() => { socketReconectando.value = true }, UMBRAL_AVISO_MS);
        }
        const espera = Math.min(1000 * 2 ** intentos, ESPERA_MAXIMA_MS);
        intentos++;
        console.log(`Reconexión del websocket en ${espera / 1000}s (intento ${intentos})`);
        temporizadorReconexion = setTimeout(() => {
            temporizadorReconexion = null;
            conectarSocket();
        }, espera);
    }

    // al volver la red no se espera al siguiente intento programado
    function reconectarAlVolverLaRed(){
        if (ws && (ws.readyState === WebSocket.CONNECTING || ws.readyState === WebSocket.OPEN)) return;
        clearTimeout(temporizadorReconexion);
        temporizadorReconexion = null;
        intentos = 0;
        conectarSocket();
    }

    function conectarSocket(){
        const url = import.meta.env.VITE_WEBSOCKET_URL

        const socket = new WebSocket(url);
        ws = socket;
        socket.onopen = function (e) {
            console.log('Conectado al websocket');
            intentos = 0;
            clearTimeout(temporizadorAviso);
            temporizadorAviso = null;
            socketReconectando.value = false;
            // las notificaciones que llegaron durante el corte están en BD
            if (huboDesconexion) {
                huboDesconexion = false;
                cargarNotificaciones();
            }
        };
        socket.onmessage = function (e) {
            console.log('Mensaje recibido: ', e.data)
            try {
                let data = JSON.parse(e.data)
                notificacionNavegador(data.message)
                notificaciones.value.unshift(data);
            } catch (error) {
                console.log('Error al parsear el mensaje del websocket')
            }
        };

        // Chrome no dispara `error` cuando cae una conexión ya abierta, solo `close`;
        // y tras un `error` siempre llega `close`. Por eso se reconecta solo desde aquí.
        socket.onclose = function (e) {
            if (ws !== socket) return;
            console.log('Desconectado del websocket (código ' + e.code + ')');
            huboDesconexion = true;
            programarReconexion()
        };
    }

    onMounted(() => {
        // @ts-ignore
        htmlBar.value = document.getElementById('settings');
        localStorage.removeItem('intentos_websocket')
        window.addEventListener('online', reconectarAlVolverLaRed)
        cargarNotificaciones()
        conectarSocket()
    });

    onUnmounted(() => {
        desmontado = true;
        window.removeEventListener('online', reconectarAlVolverLaRed)
        clearTimeout(temporizadorReconexion);
        clearTimeout(temporizadorAviso);
        if (ws) {
            ws.onclose = null;
            ws.close();
        }
    });

</script>


<template>
    <NavBar />
    <LeftBar />
    <div class="content-page">
        <div class="content">
            <router-view :key="$route.fullPath" v-slot="{ Component }">
                <component :is="Component" />
            </router-view>
        </div>
    </div>
</template>